import $ from "jquery";
import prestashop from "prestashop";
const svgNS = "http://www.w3.org/2000/svg";
function mettiCerchio() {
  var myc = document.getElementById("cerchio");
  var svg = document.getElementById("svgimg");
  var stile = "text-anchor: middle;";
  var dimcentro = "font-size:62px";
  var dimextra = "font-size:58px";
  var fontitalic = "snellround";
  var fontnormal = "bodoni";
  var cbordo = valoColo("pa_cmowa-colore-bordo");
  var csfondo = valoColo("pa_cmowa-colore-sfondo");
  var ctesto = valoColo("pa_cmowa-colore-carattere");
  let testo = "";
  testo = document.getElementById("owacustomfield").value;
  let postesto = valoSel("group_3");
  console.log("postesto:" + postesto);
  if (postesto != null) {
    if (postesto == "5") {
      postesto = "alto";
    } else if (postesto == "6") {
      postesto = "basso";
    } else {
      postesto = "centro";
    }
  }
  var tipotesto = valoSel("group_2");
  console.log("tipotesto:" + tipotesto);
  if (tipotesto != null) {
    if (tipotesto == "3") {
      tipotesto = "italic";
    } else {
      tipotesto = "normal";
    }
  }
  console.log("tipo testo:" + tipotesto + " postesto:" + postesto);
  var xtesto = 250;
  if (cbordo != "") {
    myc.setAttributeNS(null, "stroke", cbordo);
  }
  console.log("SFONDO:" + csfondo);
  if (csfondo != "") {
    myc.setAttributeNS(null, "fill", "url(#" + csfondo + ")");
  }
  var colotesto = "#000000";
  if (ctesto != null && ctesto != "") {
    colotesto = ctesto;
  }
  var txtalto = document.getElementById("txtalto");
  var txtcentro = document.getElementById("txtcentro");
  var txtbasso = document.getElementById("txtbasso");
  var stilepieno = stile + "fill:" + colotesto + ";";
  var stilevuoto = stile + "fill:rgba(15,15,15,0.0)";
  if (tipotesto != null) {
    stilepieno += ";font-style:" + tipotesto;
    if (tipotesto == "italic") {
      stilepieno += ";font-family:" + fontitalic + ";";
      xtesto = 242;
    } else {
      stilepieno += ";font-family:" + fontnormal + ";";
    }
  }
  var stilepienocentro = stilepieno;
  var stilepienoextra = stilepieno;
  stilepienocentro += ";" + dimcentro;
  stilepienoextra += ";" + dimextra;
  var atxt = [txtalto, txtcentro, txtbasso];
  var txt = null;
  for (var i = 0; i < atxt.length; i++) {
    atxt[i].setAttributeNS(null, "style", stilevuoto);
    if (atxt[i].getAttribute("attivo") == 1) {
      txt = atxt[i];
    }
  }
  if (postesto == "alto") {
    txtalto.setAttributeNS(null, "style", stilepienoextra);
    txt = txtalto;
  } else if (postesto == "basso") {
    txtbasso.setAttributeNS(null, "style", stilepienoextra);
    txt = txtbasso;
  } else {
    txtcentro.setAttributeNS(null, "style", stilepienocentro);
    txt = txtcentro;
  }
  console.log("Cambio il testo 1.0");
  if (testo != null) {
    if (txt != null) {
      txt.setAttribute("attivo", "1");
      txt.textContent = testo;
      txt.setAttributeNS(null, "x", xtesto);
    }
  }
  var div = document.createElement("div");
  div.appendChild(svg.cloneNode(true));
  var dom = new DOMParser().parseFromString(div.innerHTML, "application/xml");
  svg.parentNode.replaceChild(document.importNode(dom.documentElement, true), svg);
}
function valoColo(tipo) {
  let valo = "";
  let idgruppo = "";
  let campodata = "";
  if (tipo == "pa_cmowa-colore-sfondo") {
    idgruppo = "#group_6";
    campodata = "nome";
  } else if (tipo == "pa_cmowa-colore-bordo") {
    idgruppo = "#group_5";
    campodata = "colore";
  } else if (tipo == "pa_cmowa-colore-carattere") {
    idgruppo = "#group_4";
    campodata = "colore";
  }
  console.log("Valocolo: " + tipo + " " + idgruppo + " " + campodata);
  let checks = jQuery(idgruppo + " input.custom-control-input:checked");
  if (checks != null && checks.length > 0) {
    let chk = checks[0];
    valo = jQuery(chk).data(campodata);
    if (campodata == "nome") {
      valo = valo.toLowerCase();
    }
    console.log(valo);
  }
  return valo;
}
function valoSel(id) {
  var ret = "";
  var sel = document.getElementById(id);
  console.log("id:" + id + "->");
  console.log(sel);
  if (sel != null && sel.options != null && sel.selectedIndex >= 0) {
    ret = sel.options[sel.selectedIndex].value;
  }
  return ret;
}
function cambiaColore(ele) {
  mettiCerchio();
}
function creaImmagine() {
  var mySVG = document.getElementById("svgimg"), can = document.createElement("canvas"), ctx = can.getContext("2d"), tgtImage = document.querySelector("#pngimg"), loader = new Image();
  can.width = 500;
  can.height = 500;
  loader.width = can.width;
  loader.height = can.height;
  loader.onload = function() {
    ctx.drawImage(loader, 0, 0, loader.width, loader.height);
    tgtImage.src = can.toDataURL();
  };
  var svgAsXML = new XMLSerializer().serializeToString(mySVG);
  loader.src = "data:image/svg+xml," + encodeURIComponent(svgAsXML);
}
jQuery(document).ready(function() {
  console.log("ready prod 3.1 ");
  mettiCerchio();
  if ($("body#checkout").length === 1) {
    checkIndirizzo();
  }
  if (typeof prestashop !== "undefined") {
    console.log("prestashop ok");
    prestashop.on(
      "updateProduct",
      function(event) {
        mettiCerchio();
      }
    );
    prestashop.on(
      "updatedProduct",
      function(event) {
        mettiCerchio();
      }
    );
  }
});
